import template from './expense-review-details.html';
import controller from './expense-review-details.controller';

let expenseReviewDetailsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default expenseReviewDetailsComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/expense-review-details/expense-review-details.component.js